import { LocalizationService } from "../../../../../services/localization-service";
import { Util } from "../../../../../utils/util";

/**
 * Renders a section header in the customize item UI, optionally including a "Choose One" or "Choose Many" label.
 */
export class CustomizeItemSectionHeader {
    private readonly _localizationService: LocalizationService;
    private readonly _isChooseOne: boolean;
    private readonly _isChooseMany: boolean;
    private readonly _containerElement: HTMLElement;

    /**
     * @param {LocalizationService} localizationService - Service for retrieving localized UI strings.
     * @param {string} header - The main title of the section.
     * @param {boolean} [isChooseOne=true] - Whether to display the "Choose One" helper text.
     * @param {boolean} [isChooseMany=false] - Whether to display the "Choose Many" helper text.
     */
    constructor(localizationService: LocalizationService, header: string, isChooseOne: boolean = true, isChooseMany: boolean = false) {
        this._localizationService = localizationService;
        this._isChooseOne = isChooseOne;
        this._isChooseMany = isChooseMany;

        this._containerElement = this._createSectionHeader(header);
    }

    /**
     * Gets the rendered section header element.
     * 
     * @returns {HTMLElement} The header element for use in the DOM.
     */
    public get element(): HTMLElement {
        return this._containerElement;
    }

    /**
     * Creates the section header DOM element with title and optional helper text.
     *
     * @param {string} header - The title to display in the section.
     * @returns {HTMLElement} The DOM element containing the section header.
     */
    private _createSectionHeader(header: string): HTMLElement {
        let chooseString = "";
        if (this._isChooseOne)
            chooseString = this._localizationService.names("ChooseOne");
        else if (this._isChooseMany)
            chooseString = this._localizationService.names("ChooseMany");

        const html = `
            <div class="item-section-header">
                <h2>${header}</h2>
                <span>${chooseString}</span>
            </div>`;

        return Util.createHtmlElementFromTemplate(html);
    }
}